import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var bodyStyle = 'fx_e395032e_1kkjbsh9';
var contentInnerStyle = 'fx_e395032e_1kkjbsh8';
var contentPositionerStyle = 'fx_e395032e_1kkjbsh4';
var contentStyle = 'fx_e395032e_1kkjbsh7';
var descriptionStyle = 'fx_e395032e_1kkjbshb';
var fogStyle = 'fx_e395032e_1kkjbsh1';
var footerStyle = createRuntimeFn({defaultClassName:'fx_e395032e_1kkjbshc',variantClassNames:{orientation:{vertical:'fx_e395032e_1kkjbshd',horizontal:'fx_e395032e_1kkjbshe'}},defaultVariants:{},compoundVariants:[]});
var portalContainerStyle = 'fx_e395032e_1kkjbshf';
var scrollAreaViewportStyle = 'fx_e395032e_1kkjbsh0';
var titleStyle = 'fx_e395032e_1kkjbsha';

export { bodyStyle, contentInnerStyle, contentPositionerStyle, contentStyle, descriptionStyle, fogStyle, footerStyle, portalContainerStyle, scrollAreaViewportStyle, titleStyle };
//# sourceMappingURL=dialog.vanilla.mjs.map
